import { isArray, isObject, isString } from 'lodash-es'

/**
 *
 * @description: classNames库，支持数组对象等
 * classNames('foo', 'bar'); // => 'foo bar'
 * classNames('foo', { bar: true }); // => 'foo bar'
 *  calssNames({ 'foo-bar': true }); // => 'foo-bar'
 */
function classNames(...args: any[]) {
  const classes = [] as any
  for (let i = 0; i < args.length; i++) {
    const arg = args[i] as Record<string, string>
    if (!arg) { continue }
    if (isString(arg)) {
      classes.push(arg)
    }
    else if (isArray(arg)) {
      const inner = classNames.bind(arg)
      if (inner) {
        classes.push(inner)
      }
    }
    else if (isObject(arg)) {
      for (const key in arg) {
        if (arg[key]) {
          classes.push(key)
        }
      }
    }
  }
  return classes.join(' ')
}

export default classNames
